import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconConductor: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconConductor"><Path d="M16.5 21V15.5L20.8004 12.0597C21.2267 11.7187 21.4151 11.1604 21.2827 10.6308C21.0347 9.6388 19.8224 9.21985 18.9682 9.78192C17.1902 10.9519 14.3866 12.5 12 12.5C9.61341 12.5 6.80984 10.9519 5.03176 9.78192C4.17758 9.21985 2.9653 9.6388 2.7173 10.6308C2.58489 11.1604 2.77332 11.7187 3.19963 12.0597L7.5 15.5V21" stroke="currentColor"/><Circle cx="12" cy="6.4502" r="3" stroke="currentColor"/><Path d="M19.5 9.5L21 2" stroke="currentColor"/></CentralIconBase>;
});

export default IconConductor;
